export const getCarImagePath = (name: string, isSmall: boolean = true) => {
    if (!name) return ''
    const cleanName = name.toLowerCase().replace(/[^a-z0-9]/g, '');
    return `/cars/${isSmall ? 'small/' : ''}${cleanName}.png`;
};